import styled from "styled-components";

export const ChallengeDetailContainer = styled.div`
  padding: 20px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
`;